module.exports = __webpack_public_path__ + "img/avbi04e.2eb90684.png";